import React, { FC, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import MyPageLayout from '../../../components/Layouts/MyPage/MyPageLayout.index';
import { RootState } from '../../../store/reducers';
import FW from '../../../config/word.json';
import {
  POST_VISITOR_REGISTER_INITIAL,
  POST_VISITOR_REGISTER_REQUEST,
  VISITOR_REGISTER_CONFIRM_DISPATCH_INIT,
  VISITOR_REGISTER_DISPATCH_INIT,
  VISITOR_COMPLETE_DISPATCH,
} from '../../../store/actions';

const youbiMap = ['日', '月', '火', '水', '木', '金', '土'];

const formatDateTime = (dateStr: string, startTimeStr: string, endTimeStr: string) => {
  if (!dateStr || dateStr.length !== 8) return '';

  const year = dateStr.slice(0, 4);
  const month = dateStr.slice(4, 6);
  const day = dateStr.slice(6, 8);

  const date = new Date(parseInt(year, 10), parseInt(month, 10) - 1, parseInt(day, 10));
  const youbi = youbiMap[date.getDay()];

  const formatTime = (timeStr: string) => {
    if (!timeStr || timeStr.length !== 4) return '';
    const hours = parseInt(timeStr.slice(0, 2), 10);
    const minutes = timeStr.slice(2, 4);
    return `${hours.toString().padStart(2, '0')}:${minutes}`;
  };

  const startTime = formatTime(startTimeStr || '');
  const endTime = formatTime(endTimeStr || '');

  return `${parseInt(year, 10)}年${parseInt(month, 10)}月${parseInt(day, 10)}日(${youbi}) ${startTime}~${endTime}`;
};

const formatBirthday = (dateStr: string) => {
  if (!dateStr || dateStr.length !== 8) return dateStr || '';
  const year = dateStr.slice(0, 4);
  const month = dateStr.slice(4, 6);
  const day = dateStr.slice(6, 8);
  return `${parseInt(year, 10)}年${parseInt(month, 10)}月${parseInt(day, 10)}日`;
};

const VisitorRegisterConfirm: FC = () => {
  const clubId = Number(sessionStorage.getItem('scheduleQueryParam_clubCode'));
  const visitorData = useSelector((state: RootState) => state.visitorRegisterConfirm.visitorRegisterConfirm);
  const postResult = useSelector((state: RootState) => state.visitorRegisterConfirm.visitorRegisterPost);

  const dispatch = useDispatch();
  const history = useHistory();

  const [message, setMessage] = useState('');
  // 0:初回登録、1:確定後登録
  const [isConfirmed, setIsConfirmed] = useState('0');

  useEffect(() => {
    if (!visitorData.telephone) {
      history.push('/register');
    }
    dispatch({
      type: POST_VISITOR_REGISTER_INITIAL,
    });
    window.scrollTo(0, 0);
    setMessage('');
    setIsConfirmed('0');
    return () => {
      dispatch({
        type: POST_VISITOR_REGISTER_INITIAL,
      });
      setMessage('');
      setIsConfirmed('0');
    };
  }, [dispatch, history]);

  const handleBack = () => {
    // 戻るボタンの処理
    dispatch({
      type: POST_VISITOR_REGISTER_INITIAL,
    });
    history.push('/register');
  };

  const handleSubmit = () => {
    // 送信するボタンの処理
    dispatch({
      type: POST_VISITOR_REGISTER_REQUEST,
      payload: {
        clubId,
        contentsId: visitorData.contentsId || 0,
        eqsId: visitorData.eqsId || 0,
        contentsDate: visitorData.contentsDate || '',
        startTime: visitorData.startTime || '',
        endTime: visitorData.endTime || '',
        companion: visitorData.companion || 0,
        fullFirstName: visitorData?.firstName,
        fullLastName: visitorData?.lastName,
        kanaFirstName: visitorData.visitorMei,
        kanaLastName: visitorData.visitorSei,
        mail: `${visitorData.emailUsername}@${visitorData.emailDomain}`,
        birthday: visitorData.birthday,
        tel: visitorData.telephone,
        sex: visitorData.sex,
        isConfirmed: Number(isConfirmed),
      },
      history,
    });
  };

  useEffect(() => {
    if (isConfirmed === '2' || isConfirmed === '3') {
      dispatch({
        type: POST_VISITOR_REGISTER_REQUEST,
        payload: {
          clubId,
          contentsId: visitorData.contentsId || 0,
          eqsId: visitorData.eqsId || 0,
          contentsDate: visitorData.contentsDate || '',
          startTime: visitorData.startTime || '',
          endTime: visitorData.endTime || '',
          companion: visitorData.companion || 0,
          fullFirstName: visitorData?.firstName,
          fullLastName: visitorData?.lastName,
          kanaFirstName: visitorData.visitorMei,
          kanaLastName: visitorData.visitorSei,
          mail: `${visitorData.emailUsername}@${visitorData.emailDomain}`,
          birthday: visitorData.birthday,
          tel: visitorData.telephone,
          sex: visitorData.sex,
          isConfirmed: Number(isConfirmed),
        },
        history,
      });
    }
  }, [dispatch, history, isConfirmed]);

  useEffect(() => {
    if (postResult.isLoaded) {
      if (postResult.result !== 0) {
        setMessage(postResult.message || '');
      } else {
        setMessage('');
        // ビジター登録に成功した場合、セッションをクリアし、完成画面へ遷移
        sessionStorage.removeItem('visitorRegister_cacheObj');
        dispatch({
          type: VISITOR_REGISTER_DISPATCH_INIT,
        });
        dispatch({
          type: VISITOR_REGISTER_CONFIRM_DISPATCH_INIT,
        });
        dispatch({
          type: POST_VISITOR_REGISTER_INITIAL,
        });
        dispatch({
          type: VISITOR_COMPLETE_DISPATCH,
          visitorInfo: {
            contentsId: visitorData?.contentsId || 0,
            eqsId: visitorData?.eqsId || 0,
            contentsDate: visitorData?.contentsDate || '',
            startTime: visitorData?.startTime || '',
            endTime: visitorData?.endTime || '',
            companion: visitorData?.companion || 0,
            firstName: visitorData?.firstName || '',
            lastName: visitorData?.lastName || '',
            visitorSei: visitorData?.visitorSei || '',
            visitorMei: visitorData?.visitorMei || '',
            birthday: visitorData.birthday,
            sex: visitorData.sex,
            emailUsername: visitorData.emailUsername || '',
            emailDomain: visitorData.emailDomain || '',
            telephone: visitorData.telephone,
            isChecked: visitorData.isChecked,
            contentsName: visitorData?.contentsName || '',
            shopName: visitorData?.shopName || '',
            eqsName: visitorData?.eqsName || '',
            spaceName: visitorData?.spaceName || '',
            isAnnex: visitorData?.isAnnex || false,
            clubAddress: visitorData?.clubAddress,
          },
        });
        history.push('/register/complete');
      }
    }
  }, [dispatch, history, postResult.isLoaded]);

  return (
    <MyPageLayout>
      <section className="p-title-area">
        <p className="c-title">入力内容を確認してください</p>
      </section>
      <section className="p-content-area u-gap50 u-pb0">
        <div className="p-content-area__column p-content-area__column--width800 u-gap30 u-sp-gap20">
          <div className="p-reservation-card u-sp-gap10">
            <div className="p-reservation-card__header">
              <p className="p-reservation-card__row-text">
                {visitorData.shopName || ''}
                {visitorData.isAnnex === true ? (
                  <>
                    <span className="c-genre-label">別館</span>
                  </>
                ) : (
                  <></>
                )}
              </p>
              <div className="p-reservation-card__title">{visitorData?.contentsName || ''}</div>
            </div>
            <div className="p-reservation-card__details">
              <dl className="p-detail-list">
                <div className="p-detail-list__item">
                  <dt className="p-detail-list__label">実施日時</dt>
                  <dd className="p-detail-list__value">
                    {visitorData?.contentsDate
                      ? formatDateTime(visitorData.contentsDate, visitorData.startTime || '', visitorData.endTime || '')
                      : ''}
                  </dd>
                </div>

                {/* <!-- アコーディオン --> */}
                <div className="p-detail-list__accordion-box">
                  <div className="p-detail-list__accordion-label">店舗名</div>
                  <div className="p-detail-list__accordion-value">
                    {visitorData?.shopName || ''}
                    {visitorData?.isAnnex === true ? (
                      <>
                        <span className="c-genre-label c-genre-label--large">別館</span>
                      </>
                    ) : (
                      <></>
                    )}
                  </div>
                </div>

                <div className="p-detail-list__item">
                  <dt className="p-detail-list__label">スペース</dt>
                  <dd className="p-detail-list__value">
                    {/* A・レンタルクラブ設置席 */}
                    {visitorData.eqsName ? visitorData.eqsName : ''}
                    {visitorData.eqsName && visitorData.spaceName ? '・' : ''}
                    {visitorData.spaceName ? visitorData.spaceName : ''}
                  </dd>
                </div>

                <div className="p-detail-list__item">
                  <dt className="p-detail-list__label">同行者</dt>
                  <dd className="p-detail-list__value">
                    {visitorData?.companion !== null ? `${visitorData?.companion}名` : ''}
                  </dd>
                </div>
              </dl>
            </div>
            <div className="p-reservation-card__footer no-data" style={{ borderTop: 'none' }} />
          </div>
          <div className="p-info-card">
            <div className="p-info-card__title ">ご予約者情報</div>
            <div className="p-info-card__list">
              <div className="p-form-confirm reservator-info-form-item">
                <span className="p-form-confirm__label p-form-confirm__label--width145 reservator-info-form-item-label ">
                  お名前
                </span>
                <div className="p-form-confirm__text reservator-info-form-item-text">
                  {visitorData?.lastName || ''}
                  {visitorData?.lastName && visitorData?.firstName ? ' ' : ''}
                  {visitorData?.firstName || ''}
                </div>
              </div>

              <div className="p-form-confirm reservator-info-form-item">
                <span className="p-form-confirm__label p-form-confirm__label--width145 reservator-info-form-item-label">
                  ふりがな
                </span>
                <div className="p-form-confirm__text reservator-info-form-item-text">
                  {visitorData?.visitorSei || ''}
                  {visitorData?.visitorSei && visitorData?.visitorMei ? ' ' : ''}
                  {visitorData?.visitorMei || ''}
                </div>
              </div>

              <div className="p-form-confirm reservator-info-form-item">
                <div className="p-form-confirm__label p-form-confirm__label--width145 reservator-info-form-item-label">
                  生年月日
                </div>
                <div className="p-form-confirm__text reservator-info-form-item-text">
                  {formatBirthday(visitorData?.birthday || '')}
                </div>
              </div>
              <div className="p-form-confirm reservator-info-form-item">
                <div className="p-form-confirm__label  p-form-confirm__label--width145 reservator-info-form-item-label">
                  性別
                </div>
                <div className="p-form-confirm__text reservator-info-form-item-text">
                  {visitorData?.sex === '1' ? '男性' : '女性'}
                </div>
              </div>

              <div className="p-form-confirm reservator-info-form-item">
                <span className="p-form-confirm__label p-form-confirm__label--width145 reservator-info-form-item-label">
                  連絡先電話番号
                </span>
                <div className="p-form-confirm__text reservator-info-form-item-text">
                  {visitorData?.telephone || ''}
                </div>
              </div>

              <div className="p-form-confirm reservator-info-form-item">
                <span className="p-form-confirm__label p-form-confirm__label--width145 reservator-info-form-item-label">
                  メールアドレス
                </span>
                <div className="p-form-confirm__text reservator-info-form-item-text">
                  {visitorData?.emailUsername || ''}@{visitorData?.emailDomain || ''}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
        <div
          style={{
            color: '#d60035',
            textAlign: 'start',
            whiteSpace: 'break-spaces',
            wordBreak: 'break-all',
            gridColumnStart: '2',
          }}
        >
          {postResult.isLoaded && postResult.result === 1 && message ? message : ''}
        </div>
        <section
          className="p-button-area"
          style={{ width: '100%', minHeight: 'auto', padding: '0', margin: '20px 0 80px 0' }}
        >
          <button
            type="button"
            className="c-button c-button--secondary c-button--large c-button--prev-gray"
            onClick={handleBack}
          >
            戻る
          </button>
          <button type="button" className="c-button c-button--primary c-button--large" onClick={handleSubmit}>
            {postResult.isLoading ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />
                {FW.F_W_LOADING}
              </>
            ) : (
              <>送信する</>
            )}
          </button>
        </section>
      </div>
    </MyPageLayout>
  );
};

export default VisitorRegisterConfirm;
